var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorfinderPlugin = function SvgColorfinderPlugin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.75,
    d: "M17.401 16.072H6.6a.224.224 0 0 1-.224-.224V8.156c0-.123.1-.223.224-.223H17.4c.124 0 .224.1.224.223v7.692c0 .123-.1.223-.224.223Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 0.6,
    d: "M10.154 13.624v-3.25c0-.242.255-.399.47-.289l3.047 1.547a.324.324 0 0 1 .012.572l-3.047 1.703a.324.324 0 0 1-.482-.283Z"
  })));
};
export default SvgColorfinderPlugin;